import { Icon, Modal } from 'antd';
import React, { createRef, forwardRef, memo, useImperativeHandle, useState } from 'react';
import imgSrc from '../../assets/images/auth-qr-code.png';

interface ModalInst {
  show: () => void;
}

export const modalRef = createRef<ModalInst>();

const NoAuthModal = forwardRef<ModalInst>((_, ref) => {
  const [visible, setVisible] = useState(false);

  useImperativeHandle(ref, () => ({ show: () => setVisible(true) }));

  return (
    <Modal visible={visible} bodyStyle={{ textAlign: 'center' }} onCancel={() => setVisible(false)} footer={null}>
      <div style={{ display: 'inline-flex', alignItems: 'center', marginBottom: 16 }}>
        <Icon type='info-circle' theme='filled' style={{ fontSize: 20, color: '#faad14' }} />
        <span style={{ fontSize: 16, marginLeft: 8 }}>请先完成账号授权接入，添加客服一对一快速上手</span>
      </div>
      <img src={imgSrc} width={200} height={200} />
    </Modal>
  );
});

export const Layer = memo(() => <NoAuthModal ref={modalRef} />);
